import { useConfigurationValueFormatter } from "@plansoft-configuration-renderer/localization";
import { useConfigurationLanguage } from "../useConfigurationLanguage";
import { useConfigurationValueUnit } from "../useConfigurationUnit";
import { useCsAttribute } from "../useCsAttribute";
import { useCsValue } from "../useCsValue";
/**
 * Displays the label (name or formatted value) of the current value.
 * @category Hook
 * @returns
 */
export function useConfigurationValueLabel() {
    const attribute = useCsAttribute();
    const value = useCsValue();
    const localeCode = useConfigurationLanguage();
    const formatter = useConfigurationValueFormatter({ localeCode });
    const unitText = useConfigurationValueUnit({ mode: "symbol" });
    const label = formatter(attribute, value);
    if (label && unitText) {
        return `${label} ${unitText}`;
    }
    return label;
}
//# sourceMappingURL=useConfigurationValueLabel.js.map